/**
 * @file paddle pilot qr code
 * @author wanzhongyun
 */

import { Popover, BackTop } from 'antd';
import React from 'react';
import { IPilotQRCode } from './../../type';

import './style.less';


const PilotFixedQRCode: React.FC<IPilotQRCode> = React.memo(props => {

    const { qrCodeUrl } = props;

    const content = <div className='popover-content'>
        <div className='popover-content-tips'>报名请扫码</div>
        <img className='popover-content-image' src={qrCodeUrl} alt='' />
    </div>;

    return (
        <div className='paddle-pilot-qr-code-wrapper'>
            <Popover placement="left" title='' content={content} trigger="hover" overlayClassName='qr-code-popover-wrapper'>
                <div className='qr-code-popover'>
                    <span className='qr-code-icon' />
                    <span className='qr-code-name'>申请报名</span>
                </div>
            </Popover>

            <BackTop>
                <div className='qr-code-close-wrapper'>
                    <span className='qr-code-close' />
                </div>
            </BackTop>
        </div>
    )
});

export default PilotFixedQRCode;